// extracted by mini-css-extract-plugin
module.exports = {"h2_subtitle":"ContactMe_h2_subtitle__3_pzz","item":"ContactMe_item__3Sq8o","item_contact":"ContactMe_item_contact__1S3bx","link":"ContactMe_link__1LdiW"};